import FormularioGeneral from "./Formularios/FormularioGeneral";
import React from "react";
import FormularioUnidadCuarentenaria from "./Formularios/FormularioUnidadCuarentenaria";
import FormularioEntreEspecie from "./Formularios/FormularioEntreEspecie";
import FormularioDesdePlanta from "./Formularios/FormularioDesdePlanta";
import FormularioGeneralPlantas from "./Formularios/FomularioGeneralPlantas";
import FormularioHaciaPlanta from "./Formularios/FormularioHaciaPlanta";

const Transversales = ({
  formulario,
  selected,
  configuracion,
  species,
  handleSelect,
  isloadingInfo,
  setconfiguracion,
}) => {
  let component;

  // 🔥 KEY CRÍTICO
  const componentKey = `${formulario}-${selected}`;

  if (formulario === "1") {
    component = (
      <FormularioEntreEspecie
        key={componentKey}
        configuracion={configuracion}
        formulario={formulario}
        species={species}
        selected={selected}
        isloadingInfo={isloadingInfo}
      />
    );
  } else if (formulario === "2") {
    component = (
      <FormularioGeneral
        key={componentKey}
        configuracion={configuracion}
        formulario={formulario}
        selected={selected}
        species={species}
        handleSelect={handleSelect}
        isloadingInfo={isloadingInfo}
      />
    );
  } else if (formulario === "3") {
    component = (
      <FormularioUnidadCuarentenaria
        key={componentKey}
        configuracion={configuracion}
        formulario={formulario}
        selected={selected}
        species={species}
        handleSelect={handleSelect}
        isloadingInfo={isloadingInfo}
      />
    );
  } else if (formulario === "4") {
    component = (
      <FormularioDesdePlanta
        key={componentKey}
        configuracion={configuracion}
        formulario={formulario}
        selected={selected}
        species={species}
        handleSelect={handleSelect}
        isloadingInfo={isloadingInfo}
        setconfiguracion={setconfiguracion}
      />
    );
  } else if (formulario === "5") {
    component = (
      <FormularioHaciaPlanta
        key={componentKey}
        configuracion={configuracion}
        formulario={formulario}
        selected={selected}
        species={species}
        handleSelect={handleSelect}
        isloadingInfo={isloadingInfo}
      />
    );
  } else if (formulario === "6") {
    component = (
      <FormularioGeneralPlantas
        key={componentKey}
        configuracion={configuracion}
        formulario={formulario}
        selected={selected}
        species={species}
        handleSelect={handleSelect}
        isloadingInfo={isloadingInfo}
      />
    );
  }

  return component;
};

export default React.memo(Transversales);